module.exports = __webpack_public_path__ + "static/tica-badge-blue-9086e17053a584a76f44eb430ad1f119.png";